import React, { Component } from 'react'

import { FillerDiv } from '../StyledComponents/Fillers'
import SettingsRowSwitch from '../Settings/SettingsRowSwitch'
import SettingsRowEmpty from '../Settings/SettingsEmptyRow'
import { SelectionNavigator, SelectionNavigatorBackLink, SelectionNavigatorTitle, SelectionBackImage } from '../StyledComponents/Selection'

class FilterView extends Component {
    render() {
        const { filters, onClose, onFilterChange } = this.props

        return (
            <FillerDiv>
                <SelectionNavigator>
                    <SelectionNavigatorBackLink onClick={() => onClose()}>
                        <SelectionBackImage name="angle-left" size="2x" />
                    </SelectionNavigatorBackLink>
                    <SelectionNavigatorTitle>Filter</SelectionNavigatorTitle>
                </SelectionNavigator>
                <SettingsRowEmpty />
                <FillerDiv>
                    <FillerDiv>
                        <SettingsRowSwitch
                            checked={filters.favorites || false}
                            handleChange={() => onFilterChange('favorites', !filters.favorites)}
                            isFirst
                            title="Favoriten"
                        />
                    </FillerDiv>
                </FillerDiv>
                <SettingsRowEmpty />
            </FillerDiv>
        )
    }
}

export default FilterView



// WEBPACK FOOTER //
// ./src/components/Plant/FilterView.js